import { render, staticRenderFns } from "./auctionlist.vue?vue&type=template&id=4b6a8b44&scoped=true&"
import script from "./auctionlist.vue?vue&type=script&lang=js&"
export * from "./auctionlist.vue?vue&type=script&lang=js&"
import style0 from "./auctionlist.vue?vue&type=style&index=0&id=4b6a8b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6a8b44",
  null
  
)

export default component.exports